<template>
  <div>
    <v-row>
      <v-col v-if="linkAccountFailed" cols="12">
        <gg-card>
          <gg-card-text>
            Please, contact Your affiliate manager.
          </gg-card-text>
        </gg-card>
      </v-col>
      <template v-else>
        <v-col cols="12" md="6">
          <account-information :loading="loading" />
        </v-col>
        <v-col cols="12" md="6">
          <v-skeleton-loader :loading="loading" type="article">
            <account-overview type="month" title="Statistics" />
          </v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="6">
          <payment-method :loading="loading" />
        </v-col>
        <v-col cols="12" md="6">
          <classification :loading="loading" />
        </v-col>
      </template>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AccountInformation from '@/components/Affiliates/Dashboard/AccountInformation'
import AccountOverview from '@/components/Affiliates/Dashboard/AccountOverview'
import Classification from 'Components/Affiliates/Dashboard/Classification'
import PaymentMethod from 'Components/Affiliates/Dashboard/PaymentMethod'

export default {
  name: 'AffiliatesDashboard',
  components: {
    PaymentMethod,
    AccountInformation,
    AccountOverview,
    Classification
  },
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapGetters({
      profile: 'affiliates/profile',
      linkAccountFailed: 'affiliates/linkAccountFailed'
    }),
  },
  methods: {
    ...mapActions({
      getProfile: 'affiliates/getProfile',
      getMonthlyStatistics: 'affiliates/getMonthlyStatistics',
      reportError: 'reportError'
    }),
    async loadProfile () {
      this.loading = true
      try {
        await this.getProfile()
        if (this.profile !== null) {
          await this.getMonthlyStatistics()
        }
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    }
  },
  async mounted () {
    this.$nextTick(() => {
      if (!this.profile) {
        this.loadProfile()
      }
    })
  }
}
</script>
